// import {getEnumItemByValue, NEWS_TYPES} from "../common/enums";
import Extra from '../entities/extra';

const extraDataTransformationAfterFetch = (data) => {
    return new Extra(data);
};

export default extraDataTransformationAfterFetch;
